export const api = {
  AUTH: '/auth',
  CALL_CENTER_AGENT: '/call-center-agent',
  CALL_CENTER_PHONE_NUMBERS: '/call-center-phone-numbers',
  CRM_SETTINGS: '/crm/settings',
  CRM_TOKENS: '/crm/tokens',
  ENUMERATION: '/enumerations',
  USER: '/users',
  USER_ROLE_TYPES: '/user-role-types',
};
